// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"detailModal_modalContent__1Hy7f"};